import React from 'react'

export default function Card({ children }) {
  return (
    <div className="bg-white overflow-hidden shadow-md rounded-lg">
      <div className="px-4 py-5 sm:p-6">{children}</div>
    </div>
  )
}
